import React, { useRef } from "react";

// @mui
import IconButton from "@mui/material/IconButton";
import ButtonGroup from "@mui/material/ButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import AuditDrawer from "src/pages/dashboard/audit/components/audit-drawer";
import Button from "@mui/material/Button";

// auth
import { useAuthContext } from "src/auth/hooks";

// components
import Iconify from "src/components/iconify";
import PropTypes from "prop-types";

// Utils
import { useLocales } from "src/locales";

// ----------------------------------------------------------------------

export default function AuditButton({ ...props }) {
  const { t } = useLocales();
  const auditDrawer = useRef(null);

  const showDrawer = () => {
    auditDrawer.current.showDrawer();
  };

  const { hasPermission } = useAuthContext();

  return (
    <>
      {hasPermission("readAudit") ? (
        props.buttonGrid ? (
          <Tooltip title={t("audit")}>
            <Button
              onMouseDown={showDrawer}
              size={props.size ? props.size : "medium"}
              color="inherit"
            >
              <Iconify
                icon="material-symbols:history"
                sx={null}
              />
            </Button>
          </Tooltip>
        ) : (
          <ButtonGroup>
            <Tooltip title={t("audit")}>
              <IconButton
                disabled
                size="medium"
              />
              <IconButton
                size="medium"
                onClick={showDrawer}
                color="inherit"
              >
                <Iconify icon="material-symbols:history" />
              </IconButton>
            </Tooltip>
          </ButtonGroup>
        )
      ) : null}

      <AuditDrawer
        ref={auditDrawer}
        entityName={props.entityName}
        entityId={props.entityId}
      />
    </>
  );
}

AuditButton.propTypes = {
  entityName: PropTypes.string,
  buttonGrid: PropTypes.any,
  size: PropTypes.any,
  entityId: PropTypes.string,
};
